module.exports = __webpack_public_path__ + "static/media/11ActualizacionDatosEmpresa-11.3a1e34a7.png";